import { apiPath } from '../../constants';
import {
    axios,
    apiRequestOptions,
    errorRequestHandler,
    transformHttpResponse,
} from 'utils';

export const TRAINERS_REQUEST = 'FETCH_TRAINERS_REQUEST';
export const TRAINERS_FAILURE = 'FETCH_TRAINERS_FAILURE';
export const TRAINERS_SUCCESS = 'FETCH_TRAINERS_SUCCESS';

export const fetchTrainers = () => {
    return function(dispatch) {
        dispatch(fetchRequest());
        return axios(apiRequestOptions(apiPath.TRAINERS.LIST))
            .then(transformHttpResponse)
            .then(response => dispatch(fetchSuccess(response.data)))
            .catch(error => transformHttpResponse(error.response))
            .catch(error => {
                dispatch(fetchFailure(error));
                dispatch(errorRequestHandler(error));
            });
    }
};

const fetchRequest = () => {
    return {
        type: TRAINERS_REQUEST,
    }
};

const fetchFailure = (error) => {
    return {
        type: TRAINERS_FAILURE,
        error,
    }
};

const fetchSuccess = (data) => {
    return {
        type: TRAINERS_SUCCESS,
        data,
    }
};